import React, { useState } from "react";
import { Card, Tabs, Tab } from "react-bootstrap";
import { FaMapMarkerAlt, FaCalendarAlt, FaClock, FaBox } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./supplier.css";

const SupplierProfile = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const location = useLocation();
  const { supplier } = location.state || {}; // ✅ destructure properly

  if (!supplier) {
    return (
      <div className="container py-5 text-center">
        <h6 className="text-muted">Supplier details not available</h6>
      </div>
    );
  }

  const supportedProducts = supplier.supported_products || [];
  const orderItems = supplier.order_items || [];

  return (
    <div className="container py-4">
      {/* ================= HEADER ================= */}
      <Card className="shadow-sm p-4 mb-3">
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex gap-3">
            <div
              className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: 60, height: 60, fontSize: 20 }}
            >
              {supplier.company_name?.[0]}
            </div>

            <div>
              <h5 className=" mb-1">
                {supplier.company_name}
                <span className="text-success fs-6"> ✔ Verified</span>
              </h5>

              <p className="text-muted mb-0">
                Supplier for {orderItems.length} completed orders
              </p>

              <span className="badge bg-light text-dark mb-2">
                {supplier.country}
              </span>

              <div className="d-flex align-items-center gap-2">
                <span className="text-warning">★ 4.6</span>
                <span className="text-success">● Active</span>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* ================= TABS ================= */}
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3 custom-tabs"
      >
        {/* ================= OVERVIEW ================= */}
        <Tab eventKey="overview" title="Overview">
          <div className="row g-3">
            <div className="col-md-6">
              <Card className="p-3">
                <h6 className=" mb-3">Company Details</h6>

                <p>
                  <FaMapMarkerAlt className="me-2 text-muted" />
                  {supplier.address}
                </p>

                <p>
                  <FaCalendarAlt className="me-2 text-muted" />
                  Registered Company
                </p>

                <p>
                  <FaClock className="me-2 text-muted" />
                  Active Supplier
                </p>

                <p>
                  <FaBox className="me-2 text-muted" />
                  Completed Orders: {orderItems.length}
                </p>
              </Card>
            </div>

            {/* SUPPORTED PRODUCTS */}
            <div className="col-md-6">
              <Card className="p-3">
                <h6 className=" mb-3">Supported Products</h6>

                <div className="d-flex gap-2 flex-wrap">
                  {supportedProducts.length > 0 ? (
                    supportedProducts.map((p, index) => (
                      <span key={index} className="badge bg-light text-dark">
                        {p.product_name}
                      </span>
                    ))
                  ) : (
                    <span className="text-muted">No products available</span>
                  )}
                </div>
              </Card>
            </div>
          </div>
        </Tab>

        {/* ================= ORDER HISTORY ================= */}
       <Tab eventKey="orders" title="Order History">
  <Card className="p-3">
    <h6 className="mb-3 fw-semibold">Recent Orders</h6>

    {supplier.order_items && supplier.order_items.length > 0 ? (
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Items</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {supplier.order_items.map(order => (
  <tr key={order.order_id}>
    <td>ORD-{order.order_id}</td>
    <td>{new Date(order.created).toLocaleDateString()}</td>
    <td>
      {order.items.map(i => `${i.item} x ${i.quantity}`).join(", ")}
    </td>
    <td>
      ₹{order.items.reduce((sum, i) => sum + i.price * i.quantity, 0).toLocaleString("en-IN")}
    </td>
    <td>
      <span className="badge bg-success-subtle text-success">
        Delivered
      </span>
    </td>
  </tr>
))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="text-muted mb-0">No completed orders yet</p>
    )}
  </Card>
</Tab>


        {/* ================= CONTACT ================= */}
        <Tab eventKey="contact" title="Contact Info">
          <Card className="p-3">
            <h6 className="">Contact Information</h6>

            <p className="mb-1">
              <strong>Email:</strong> {supplier.supplier_email || "—"}
            </p>

            <p className="mb-1">
              <strong>Phone:</strong> {supplier.supplier_phone || "—"}
            </p>

            <p className="mb-0">
              <strong>Address:</strong> {supplier.address || "—"}
            </p>
          </Card>
        </Tab>
      </Tabs>
    </div>
  );
};

export default SupplierProfile;
